module.exports = __webpack_public_path__ + "img/pay-coupon.3942e96.png";